const trackingUtils = require('../modules/utils/tracking.utils');

const stopRenderMetric = () => {
    const isVariation = Odigeo.AB.isConvertConActive;
    const metricFlights = isVariation ? 'RENDER_FLIGHTS_B' : 'RENDER_FLIGHTS';
    const metricSecure = isVariation ? 'RENDER_SECURE_B' : 'RENDER_SECURE';
    const metricMeta = isVariation ? 'RENDER_SECURE_META_B' : 'RENDER_SECURE_META';
    trackingUtils.trackStop(getMetricConstant(metricFlights, metricSecure, metricMeta));
};

function getMetricConstant(metricFlights, metricSecure, metricMeta) {
    let metric;
    if (Odigeo.SessionScope.entryPoint === 'secure') {
        metric = Odigeo.Utils.parseJson(Odigeo.SessionScope.hasMktPortal) ? metricMeta : metricSecure;
    } else {
        metric = metricFlights;
    }
    return metric;
}

module.exports = {
    stopRenderMetric: stopRenderMetric,
};
